<div class="row">
  <div class="col-md-12">

    <div class="container-fluid">
      <div class="header-container flex">
      <span class="iso-header">
 {{ "bikeshop.thirdparty.manage.title" | translate }}
</span>
        <a (click)="addNewThirdParty()" style="margin-left:auto;width: 200px;">
          <button class="iso-round-button full-width">Add New</button>
        </a>
      </div>
      <!-- <div class="content">
        <div class="row margin-top-8">
          <div class="col-md-6 label"></div>
          <div class="col-md-3 label">
          </div>
          <div class="col-md-3">
            <div class="p-inputgroup">
              <input type="text" pInputText [(ngModel)]="search" placeholder="Search" (keyup.enter)="searchThirdParty()" />
              <span class="p-inputgroup-addon"><i class="fa hubtiger-search" (click)="searchThirdParty()"></i></span>
            </div>
          </div>
        </div>
        <div class="loading" *ngIf="loading">
          <div class="loader"></div>
        </div>
      </div> -->

      <div *ngIf="thirdParties.length > 0 && loading == false">
        <div class="menu-container">

          <div *ngFor="let thirdParty of thirdParties" class="menu-card-container">
            <div class="third-party-card">
              <a (click)="editThirdParty(thirdParty.id)">
                <div class="menu-card">
                  <div class="menu-header">
                    <div>
                      <div class="center-line"></div>
                      <div class="icon-container">
                        <img style="margin: 0 auto;"
                             src="{{ thirdParty.image == null || thirdParty.image == '' ? '../../../../../../../../assets/hubtiger_logo_pink.png' : thirdParty.image}}"/>
                      </div>
                    </div>
                  </div>
                  <div class="menu-footer">
                    <h5>{{thirdParty.name}}</h5>

                    <div class="row">
                      <div class="col-md-4">
                        <div>{{ "bikeshop.thirdparty.manage.card.contact_label" | translate }}
                          :
                        </div>
                      </div>
                      <div class="col-md-8">
                        <div>{{thirdParty.contactName}}</div>
                      </div>
                    </div>

                    <!-- <div class="row">
                      <div class="col-md-4">
                        <div>{{ "bikeshop.thirdparty.manage.card.services_label" | translate }}:</div>
                      </div>
                      <div class="col-md-8">
                        <div style="font-weight: bold;">{{thirdParty.servicesLinked.length}}</div>
                      </div>
                    </div> -->

                    <!-- <div class="row">
                      <div class="col-md-4">
                        <div>{{ "bikeshop.thirdparty.manage.card.willpay_label" | translate }}</div>
                      </div>
                      <div class="col-md-8">
                        <div style="font-weight: bold;" [ngClass]="{'text-success': thirdParty.willPay, 'text-danger': !thirdParty.willPay}">
                          {{thirdParty.willPay ? 'Yes' : 'No'}}
                        </div>
                      </div>
                    </div> -->

                    <div class="row" *ngIf="thirdParty.address">
                      <div class="col-md-4">
                        <div>{{ "bikeshop.thirdparty.manage.card.address_label" | translate }}
                          :
                        </div>
                      </div>
                      <div class="col-md-8">
                        <div>{{thirdParty.address}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>

        </div>
      </div>

      <div *ngIf="thirdParties.length === 0 && loading == false"
           style="display:flex; justify-content: center; align-items: center;">
        <h4 class="text-center">{{ "bikeshop.thirdparty.manage.noitemsfound_text" | translate }}</h4>
      </div>

      <div *ngIf="loading == true" style="display:flex; justify-content: center; align-items: center;">
        <p-progressSpinner [style]="{ width: '50px', height: '50px' }" animationDuration=".5s">
        </p-progressSpinner>
      </div>


    </div>

  </div>
</div>


<p-sidebar #NavSideBar [(visible)]="showThirdParty" position="right"
           [style]="{width:'70em', background: '#F6F6F8', 'overflow-x': 'auto'}" (onHide)="NavSideBar.destroyModal()">
  <div *ngIf="showThirdParty">
    <app-add-edit-third-party [combinedServicesUsed]="combinedServicesUsed" [editing]="editing"
                              [selectedThirdParty]="selectedThirdParty" (closeSidePanel)="closeSidePanel($event)"
                              [messageService]="messageService"></app-add-edit-third-party>
  </div>
</p-sidebar>

<p-toast position="bottom-center" key="bottom-center" styleClass="hubtiger-toast"></p-toast>
